export default "__VITE_ASSET__Cr8eB_yp__"